import { render, staticRenderFns } from "./topBar.vue?vue&type=template&id=2bcc2286&"
import script from "./topBar.vue?vue&type=script&lang=js&"
export * from "./topBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "topBar.vue"
export default component.exports